import { GetBook } from "Store/firebase/books";
import { emptyArray } from "js-vextensions";
import { StoreAccessor, GetDocs, GetDoc } from "mobx-firelink";
export const GetSelectedMapObjectID = StoreAccessor("GetSelectedMapObjectID", s => () => {
    return s.main.write.selectedObject;
});
export const GetSelectedMapObject = StoreAccessor("GetSelectedMapObject", s => () => {
    return GetMapObject(GetSelectedMapObjectID());
});
export const GetMapObjects = StoreAccessor("GetMapObjects", s => () => {
    return GetDocs({}, a => a.mapObjects);
});
export const GetMapObject = StoreAccessor("GetMapObject", s => (id) => {
    if (id == null)
        return null;
    return GetDoc({}, a => a.mapObjects.get(id));
});
export const GetMapObjectsInMap = StoreAccessor("GetMapObjectsInMap", s => (mapID) => {
    const book = GetBook(mapID);
    const rootObj = GetMapObject(book.rootMapObject);
    if (rootObj == null)
        return emptyArray;
    const result = [rootObj];
    let childrenSet = GetMapObjectChildren(rootObj);
    while (childrenSet.length) {
        const nextChildrenSet = [];
        for (const child of childrenSet) {
            if (child == null)
                continue;
            result.push(child);
            nextChildrenSet.AddRange(GetMapObjectChildren(child));
        }
        childrenSet = nextChildrenSet;
    }
    return result;
});
export const GetMapObjectChildren = StoreAccessor("GetMapObjectChildren", s => (obj) => {
    return obj.children?.VKeys().map(id => GetMapObject(id)) ?? emptyArray;
});
export function IsRootMapObject(obj) {
    return obj.parent == null;
}
export function ForCut_GetError(userID, obj) {
    const baseText = `Cannot cut map-object #${obj._key}, since `;
    //if (!IsUserCreatorOrMod(userID, obj)) return `${baseText}you are not its owner. (or a mod)`;
    //if (!asPartOfCut && (node.parents || {}).VKeys(true).length <= 1)  return `${baseText}doing so would orphan it. Try deleting it instead.`;
    if (IsRootMapObject(obj))
        return `${baseText}it's the root-object of a map.`;
    return null;
}
export const ForDelete_GetError = StoreAccessor("ForDelete_GetError", s => (userID, obj) => {
    const baseText = `Cannot delete map-object #${obj._key}, since `;
    //if (!IsUserCreatorOrMod(userID, obj)) return `${baseText}you are not the owner of this node. (or a mod)`;
    //if (GetParentCount(node) > 1) return `${baseText}it has more than one parent. Try unlinking it instead.`;
    //if (IsRootMapObject(obj) && !AsObj(subcommandInfo).asPartOfMapDelete) return `${baseText}it's the root-node of a map.`;
    if (IsRootMapObject(obj))
        return `${baseText}it's the root-object of a map.`;
    const children = GetMapObjectChildren(obj);
    if (children.Any(a => a == null))
        return "[still loading children...]";
    //if (children.map(a=>a._key).Except(AsObj(subcommandInfo).childrenBeingDeleted || []).length) {
    if (children.map(a => a._key).length) {
        return `Cannot delete this map-object (#${obj._key}) until all its children have been unlinked or deleted.`;
    }
    return null;
});
